import {takeEvery, put, call, all} from 'redux-saga/effects'
import * as api from '../api/auth'
import cookies from 'js-cookie'
import routes from '../routes'
import {message} from "antd";


function* login(action) {
    yield put({type: 'AUTH_LOGGING'});
    const {username, password, remember} = action.payload;
    try {
        const response = yield call(api.login, username, password);
        if (response.data.success) {
            const userToken = response.data.token;
            cookies.set("userToken", userToken, {expires: remember ? 30 : null});
            yield put({type: 'AUTH_LOGIN_SUCCESS', payload: userToken});
        } else {
            message.error(response.data.message);
            yield put({type: 'AUTH_LOGIN_FAIL'});
        }
    } catch (e) {
        yield put({type: 'AUTH_LOGIN_FAIL'});
    }

}

function* watchLogin() {
    yield takeEvery('AUTH_LOGIN', login);
}

function* watchGetUserInfo() {
    yield takeEvery('AUTH_GET_INFO', getUserInfo)
}

function* getUserInfo(action) {
    const userToken = action.payload;
    try {
        const userInfo = yield call(api.getUserInfo, userToken)
        yield put({
            type: 'AUTH_GET_INFO_SUCCESS', payload: {...userInfo.data, routes}
        })
    } catch (e) {
        console.log(e)
    }
}


function* logout() {
    cookies.remove("userToken");
    yield put({type: 'AUTH_LOGOUT_SUCCESS'});
}


function* watchLogout() {
    yield takeEvery('AUTH_LOGOUT', logout)
}

export default function* () {
    yield all([watchLogin(), watchGetUserInfo(), watchLogout()])
}
